<!-- metallurgy -->
<template>
  <div class="metallurgy">
    <div class="bgBox section1 ">
      <div class="s1_innerBox typeArea">
        <div class="opctBox">
          <div class="p p1">
            SUMMIT scales the heights of
          </div>
          <div class="p p1 p2">
            levitation metallurgy
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="bgBox section2 " id="悬浮冶金简介">
      <div class="s2_innerBox typeArea">
        <div class="bodyBox">
          <div class="top">
            <div class="box1">
              <div class="topTitle leftTop">
                <div class="p1">
                  <p>ABOUT</p>
                  <span>LEVITATION METALLURGY</span>
                </div>
                <div class="p2"></div>
                <div class="p4">
                  Levitation metallurgy technology, also known as vacuum electromagnetic levitation melting technology,
                  refers to the technology of using electromagnetic fields to make the molten pool in a state of
                  explosive levitating during the vacuum melting process. This is the most advanced material preparation
                  process in contemporary times, used to prepare the main materials urgently needed for national defense
                  and high-tech industries.
                </div>

              </div>
            </div>
            <div class="box2">
              <div class="imgBox">
                <img src="../../static/images/metallurgy/悬浮.png" alt="">
              </div>

            </div>
          </div>
          <div class="bottom">
            <div class="p5">
              The technology combining levitation melting with other material technologies is collectively referred to
              as levitation metallurgy technology. Vacuum melting technology eliminates the pollution of gas molecules
              on materials, besides, levitation melting technology further eliminates the pollution caused by crucible
              materials. It eliminates all sources of pollution and is the most advanced and ideal material preparation
              technology so far.
            </div>
            <div class="p5">
              It is suitable for the melting and treatment of active metals and their alloys. It eliminates the
              limitation of melting temperature by collapsed materials and can achieve a melting temperature exceeding
              3000 ° C under induction melting conditions.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3 " id="技术优势">
      <div class="s3_innerBox typeArea">
        <div class="bodyBox">
          <div class="box1">
            <div class="item" :style="section3backgroundDiv1">
              <div class="label">
                Uniform
                composition
              </div>
            </div>
            <div class="item" :style="section3backgroundDiv2">
              <div class="label">
                High purity
              </div>
            </div>
            <div class="item" :style="section3backgroundDiv3">
              <div class="label">
                High melting
                temperature
              </div>
            </div>
          </div>
          <div class="box2">
            <div class="topTitle leftTop">
              <div class="p1">
                <p>TECHNOLOGICAL</p>
                <span>ADVANTAGE</span>
              </div>
              <div class="p2"></div>
              <div class="p4">
                Levitation melting has the advantages of no pollution, high temperature, uniform composition and casting
                function
              </div>
              <div class="p5">
                This technology is suitable for the preparation of high purity metals, active metals, refractory metals,
                precious metals and alloys with complex compositions and high technical requirements.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section4 " id="应用领域">
      <div class="s4_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>APPLICATION </span>AREA
          </div>
          <div class="p2"></div>
          <div class="p4">It is used in the fields of defense technology, cutting-edge technology and advanced
            technology in modern industry</div>
        </div>
        <div class="bodyBox">
          <div class="p1">Aerospace technology area</div>
          <div class="p1">New energy technology area</div>
          <div class="p1">Information technology area</div>
          <div class="p1">Mineral refining area</div>
          <div class="p1">Nuclear energy technology</div>
          <div class="p1">Weapons material area</div>
          <div class="p1">Strategic material technology</div>
          <div class="p1">Cutting-edge new material</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'metallurgy',
    components: {},
    data() {
      return {
        section3backgroundDiv1: {
          backgroundImage: 'url(' + require('../../static/images/metallurgy/成分均匀.jpg') + ')',
        },
        section3backgroundDiv2: {
          backgroundImage: 'url(' + require('../../static/images/metallurgy/高纯度.jpg') + ')',
        },
        section3backgroundDiv3: {
          backgroundImage: 'url(' + require('../../static/images/metallurgy/温度高.jpg') + ')',
        }

      }
    },
    computed: {},
    watch: {},
    created() {
      this.init()
    },
    mounted() {
      if (this.$store.state.pageId) {
        this.$el.querySelector(this.$store.state.pageId).scrollIntoView({
          behavior: 'smooth',
          block: "start"
        })
      } else {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      this.$store.commit('savePageId', '')
    },
    methods: {
      init() {

      },
    },
  }

</script>

<style lang='less' scoped>
  .metallurgy {
    min-width: 1200px;

    height: 100%;


    .section1 {
      width: 100%;
      height: 600px;
      background: url('../../static/images/metallurgy/banner.jpg') no-repeat;
      background-position: center;

      .s1_innerBox {
        padding-top: 234px;
        text-align: left;

        .opctBox {
          width: 1245px;
          height: 300px;
          // opacity: 0.4;
          background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 2%, rgba(0, 0, 0, 0.4) 20%, rgba(0, 0, 0, 0.4) 80%, rgba(255, 255, 255, 0.1) 98%, rgba(255, 255, 255, 0) 100%);

          .p1 {
            font-size: 60px;
            line-height: 60px;
            padding-top: 50px;
            color: #fefefe;

          }
          .p2{
            padding-top: 38px;
          }
          .line {
            width: 200px;
            height: 8px;
            margin-top: 42px;
            background-color: #c30000;
          }
        }

      }
    }

    .section2 {
      width: 100%;
      height: 940px;

      .s2_innerBox {
        height: 100%;
        padding-top: 268px;

        .bodyBox {
          width: 1180px;
          height: 551px;
          padding: 0 0 20px 35px;
          background-color: transparent;
          border: solid 2px #c30000;
          z-index: 99;
          position: relative;

          .top {
            display: flex;
            height: 360px;

            .box1 {
              flex: 1;

              .topTitle {
                .p1 {
                  margin-top: 35px;

                  >p {
                    color: #545454;
                    margin-bottom: 20px;
                  }
                }

                .p3 {
                  margin-bottom: 50px;
                }

                .p4,
                .p5 {
                  font-size: 16px;
                  line-height: 28px;
                  color: #545454;
                  // text-indent: 2em;
                  padding-right: 10px;
                  font-weight: 400;
                }
              }
            }

            .box2 {
              width: 569px;
              height: 355px;
              position: relative;

              .imgBox {
                width: 622px;
                height: 408px;
                background-color: #ffffff;
                box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
                position: absolute;
                top: -53px;
                right: -53px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

            }
          }

          .bottom {
            .p5 {
              font-size: 16px;
              line-height: 28px;
              color: #545454;
              // text-indent: 2em;
              padding-right: 10px;
              font-weight: 400;
              text-align: left;
            }
          }

        }
      }
    }

    .section3 {
      width: 100%;
      height: 841px;
      background-color: #fbfbfb;
      margin-top: -190px;

      .s3_innerBox {
        height: 100%;
        padding-top: 222px;

        .bodyBox {
          width: 100%;
          height: 540px;
          display: flex;

          .box1 {
            width: 807px;
            height: 100%;
            padding-left: 45px;
            display: flex;
            justify-content: space-between;

            .item {
              width: 247px;
              height: 540px;
              background-repeat: no-repeat;
              background-position: top center;
              position: relative;

              .label {
                position: absolute;
                left: 0;
                bottom: 0;
                font-size: 24px;
                color: #ffffff;
                font-weight: 700;
                width: 100%;
                height: 70px;
                line-height: 70px;
                text-align: center;
                background-color: rgba(195, 0, 0, 0.8);
              }
            }
          }

          .box2 {
            flex: 1;
            text-align: left;
            margin-left: 21px;

            .topTitle {
              .p1 {
                margin-top: 35px;

                >p {
                  margin-bottom: 20px;
                }
              }

              .p3 {
                margin-bottom: 56px;
              }

              .p4,
              .p5 {
                font-size: 16px;
                line-height: 28px;
                color: #545454;
                //   text-indent: 2em;
                padding-right: 10px;
                font-weight: 400;
              }
            }
          }


        }
      }
    }

    .section4 {
      width: 100%;
      height: 906px;
      background: url('../../static/images/metallurgy/应用领域.jpg') no-repeat;
      background-position: center;
      margin-top: 163px;
      margin-bottom: 180px;

      .s4_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 130px;
          }

          .p4 {
            font-size: 16px;
            line-height: 16px;
            color: #545454;
            font-weight: 400;
            margin-top: 49px;
          }
        }

        .bodyBox {
          margin-top: 110px;
          width: 100%;
          height: 420px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .p1 {
            width: 280px;
            height: 88px;
            line-height: 88px;
            background-color: rgba(195, 0, 0, 0.2);
            font-size: 18px;
            font-weight: 400;
            color: #545454;
          }

          .p1:hover {
            background-color: #c30000;
            color: #ffffff;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/metallurgyEn.vue